import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'
import moment from 'moment'

const getDefaultStateForSaleChannels = () => {
    return {
        salechannels: [],
        data: {},
        is_customer_added: null,
        is_created: null,
        is_updated: null,
        is_deleted: null,
        is_retrieve: null,
        is_customer_removed:null,
        is_special_price_created:null,
        filter: {
            keyword: "",
            active_only: "1"
        }
    }
}


// state
const state = getDefaultStateForSaleChannels()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_SALE_CHANNEL (state) {
        Object.assign(state, getDefaultStateForSaleChannels())
    },
    QUICK_SEARCH(state, data) {
        data.forEach(function(element) {
            element.time_created = (element.time_created != null && element.time_created != '') ? (moment(element.time_created).format('DD/MM/YYYY, h:mm a')) : '-'
        });
        state.salechannels = data

    },
    SET_FILTER(state, data) {
        state.filter = data
    },
    SET_IS_CREATED(state, data) {
        state.is_created = data
    },
    SET_IS_UPDATED(state, data) {
        state.is_updated = data
    },
    SET_IS_DELETED(state, data) {
        state.is_deleted = data
    },
    SET_IS_REMOVED_CUSTOMER(state, data) {
        state.is_customer_removed = data
    },
    FETCH(state, data) {
        if (data) {
            state.data = data
        }
    },

    SET_CUSTOMERS(sate, data) {
        state.data.customers = data
    },
    SET_IS_CUSTOMER_ADDED(state, data) {
        if (data) {
            state.is_customer_added = data
        }
    },
    SET_IS_PRICE_ADDED(state, data)
    {
        state.is_special_price_created = data
    }
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
        commit("RESET_STATE_FOR_SALE_CHANNEL")
    },
    quickSearch({ commit }, data) {
        return axios.post(apiRoutes['SALE_CHANNEL_QUICK_SEARCH'], data, authHeader())
            .then(response => {
                if (response.data.code == 1) {
                    commit('QUICK_SEARCH', response.data.data)
                    commit('SET_FILTER', data)
                } else {
                    commit('QUICK_SEARCH', [])
                    commit('SET_FILTER', data)
                }
            })
            .catch(error => {
                if (error.response) {
                    console.log(error.response)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    console.log("Problem Searching", error);
                }
            });
    },

    async create({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['CREATE_SALE_CHANNEL'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) {
                    let doc_number = response.data.data.code
                    commit('SET_IS_CREATED', 1);
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Sale Channel (' + doc_number + ')' + " has been created!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } 
                else 
                {
                    let errors = response.data.data.errors
                    if (Array.isArray(errors)) {
                        let msg = errors.join("\n")
                        Vue.notify({
                            group: 'notify',
                            type: 'error',
                            text: msg,
                            max: 5,
                            duration: 5000,
                            speed: 300
                        })
                    }
                    commit('SET_IS_CREATED', 0);

                }

            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)

                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Application exception")
                }
            });
    },
    fetch({ commit }, data) {
        return axios.post(apiRoutes['SALE_CHANNEL_RETRIEVE'], data, authHeader())
            .then(response => {
                if (response.data.code == 1) {
                    commit('FETCH', response.data.data)
                } else {
                    commit('FETCH', {})
                }
            })
            .catch(error => {
                if (error.response) {
                    console.log(error.response)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    console.log("Problem Querying Data!", error);
                }
            });
    },
    async addCustomer({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['SALE_CHANNEL_ADD_CUSTOMER'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) {
                    let res_code = response.data.data.code
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Sale Channel Customer(' + res_code + ')' + " has been created!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })

                    commit('SET_IS_CUSTOMER_ADDED', 1);
                } 
                else 
                {
                    // If code == 0
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: response.data.msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })

                    //commit('SET_IS_CUSTOMER_ADDED', 0);
                }

            })
            .catch((error) => 
            {
                alert(error)

                if (error.response) {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Problem Adding Customer to Sale Channel")
                }
            });
    },
    async createSpecialPrice({ commit, dispatch }, data) {
        await axios.post(apiRoutes['SALE_CHANNEL_CREATE_SPECIAL_PRICE'], data, authHeader())
            .then(function(response) 
            {
                if (response.data.code == 1) 
                {
                    let res_code = response.data.data.code
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Sale Channel Price has been created!',
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })

                    commit('SET_IS_PRICE_ADDED', 1);
                } 
                else 
                {
                    let errors = response.data.data.errors

                    if(Array.isArray(errors))
                    {
                      console.log(errors)
                      let msg = errors.join("\n")
    
                      Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                    }

                    commit('SET_IS_PRICE_ADDED', 0);
                }

            })
            .catch((error) => 
            {
                commit('SET_IS_PRICE_ADDED', 0);

                if (error.response) {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Problem Adding Price to Sale Channel")
                }
            });
    },
    async update({ commit, dispatch }, data) {
        await axios.post(apiRoutes['UPDATE_SALE_CHANNEL'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) {
                    let doc_number = response.data.data.code
                    commit('SET_IS_UPDATED', 1);

                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Sale Channel (' + doc_number + ')' + " has been updated!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } 
                else 
                {
                    let errors = response.data.data.errors
                    commit('SET_IS_UPDATED', 0);
                    if (Array.isArray(errors)) {
                        console.log(errors)
                        let msg = errors.join("\n")

                        Vue.notify({
                            group: 'notify',
                            type: 'error',
                            text: msg,
                            max: 5,
                            duration: 5000,
                            speed: 300
                        })
                    }


                }

            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)

                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Problem Creating Sale Channel")
                }
            });
    },
    async delete({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['DELETE_SALE_CHANNEL'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) {
                    let doc_number = response.data.data.code
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Sale Channel (' + doc_number + ')' + " has been deleted!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                    commit('SET_IS_DELETED', 1);
                } else {
                    let errors = response.data.data.errors

                    if (Array.isArray(errors)) {
                        let msg = errors.join("\n")

                        Vue.notify({
                            group: 'notify',
                            type: 'error',
                            text: msg,
                            max: 5,
                            duration: 5000,
                            speed: 300
                        })
                    }
                    commit('SET_IS_DELETED', 0);
                }

            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)

                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Problem Creating Sale Channel")
                }
            });
    },
    async deletePrice({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['DELETE_SALE_CHANNEL_PRICE'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) 
                {
                    let doc_number = response.data.data.code
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: "Sale Channel Price has been deleted!",
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                    commit('SET_IS_DELETED', 1);
                } else {
                    let errors = response.data.data.errors

                    if (Array.isArray(errors)) {
                        let msg = errors.join("\n")

                        Vue.notify({
                            group: 'notify',
                            type: 'error',
                            text: msg,
                            max: 5,
                            duration: 5000,
                            speed: 300
                        })
                    }
                    commit('SET_IS_DELETED', 0);
                }

            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)

                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } else {
                    //console.log("Problem submitting New Post", error);
                    alert("Problem Creating Sale Channel")
                }
            });
    },
    async saveProductCategories({commit, dispatch}, data)
    {
        await axios.post(apiRoutes['SALE_CHANNEL_PRODUCT_CATEGORIES'], data, authHeader())
        .then(function(response) {
            if (response.data.code == 1) 
            {
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: 'Product Categories has been saved!',
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                commit("SET_IS_UPDATED", 1);
            } 
            else 
            {
                let errors = response.data.data.errors

                if (Array.isArray(errors)) {
                    let msg = errors.join("\n")

                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: msg,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                commit("SET_IS_UPDATED", 0);            
            }

        })
        .catch((error) => {
            if (error.response) {
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.message,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } 
            else 
            {
                alert("Problem Removing Sale Channel Customer")
            }
        });
    },
    async removeCustomer({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['SALE_CHANNEL_REMOVE_CUSTOMER'], data, authHeader())
            .then(function(response) {
                if (response.data.code == 1) 
                {
                    Vue.notify({
                        group: 'notify',
                        type: 'success',
                        text: 'Customer has been removed!',
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                    commit('SET_IS_REMOVED_CUSTOMER', 1);
                } 
                else 
                {
                    let errors = response.data.data.errors

                    if (Array.isArray(errors)) {
                        let msg = errors.join("\n")

                        Vue.notify({
                            group: 'notify',
                            type: 'error',
                            text: msg,
                            max: 5,
                            duration: 5000,
                            speed: 300
                        })
                    }
                    commit('SET_IS_REMOVED_CUSTOMER', 0);
                }

            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                } 
                else 
                {
                    alert("Problem Removing Sale Channel Customer")
                }
            });
    },
    // async fetchCustomers({ commit }, data) {
    //     return axios.post(apiRoutes['SALE_CHANNEL_RETRIEVE_CUSTOMERS'], data, authHeader())
    //         .then(response => {
    //             if (response.data.code == 1) {
    //                 commit('SET_CUSTOMERS', response.data.data)
    //             } else {

    //                 commit('SET_CUSTOMERS', [])
    //             }
    //         })
    //         .catch(error => {
    //             if (error.response) {
    //                 console.log(error.response)
    //                 Vue.notify({
    //                     group: 'notify',
    //                     type: 'error',
    //                     text: error.response.data.msg,
    //                     max: 5,
    //                     duration: 5000,
    //                     speed: 300
    //                 })
    //             } else {
    //                 console.log("Problem Querying Data!", error);
    //             }
    //         });
    // },

}

export {
    state,
    getters,
    actions,
    mutations
}